import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mapDispatchToProps } from './mapDispatchToProps';
import { mapStateToProps } from './mapStateToProps';
import { OutOfNetworkModalView } from './OutOfNetworkModalView';

/**
 * @param {string} descriptionText
 * @param {string} insuranceCarrierId
 * @param {string} insuranceName
 * @param {string} insurancePlanId
 * @param {boolean} isOnlyInNetworkBookable
 * @param {string} procedureId
 * @param {string} professionalName
 * @param {Functions_Shared_Fem_SendMetric} sendMetric
 * @param {boolean} shouldShowMentalHealthOONBenefits
 * @param {boolean} showModal
 * @param {boolean} trackClickChangeInsuranceButton
 * @param {boolean} trackClickCloseModal
 * @param {boolean} trackClickContinueBookingButton
 * @param {boolean} trackClickFindDoctorsButton
 * @returns {JSX.Element}
 * @constructor
 */
class OutOfNetworkContainerView extends Component {
    componentDidUpdate(prevProps) {
        const {
            trackModalOpened,
            showModal,
            shouldShowMentalHealthOONBenefits,
            isOnlyInNetworkBookable,
        } = this.props;

        if (showModal && !prevProps.showModal) {
            trackModalOpened({
                is_mh_test_variant: shouldShowMentalHealthOONBenefits,
                is_only_in_network_bookable: isOnlyInNetworkBookable,
            });
        }
    }

    componentDidMount() {
        const {
            trackModalOpened,
            showModal,
            shouldShowMentalHealthOONBenefits,
            isOnlyInNetworkBookable,
        } = this.props;

        if (showModal) {
            trackModalOpened({
                is_mh_test_variant: shouldShowMentalHealthOONBenefits,
                is_only_in_network_bookable: isOnlyInNetworkBookable,
            });
        }
    }

    render() {
        const {
            descriptionText,
            showModal,
            trackClickChangeInsuranceButton,
            ...props
        } = this.props;

        if (!showModal) {
            return null;
        }

        return (
            <OutOfNetworkModalView
                {...props}
                data-test="out-of-network-modal-view"
            />
        );
    }
}

const OutOfNetworkModal = connect(
    mapStateToProps,
    mapDispatchToProps
)(OutOfNetworkContainerView);

export {
    OutOfNetworkModal as default,
    OutOfNetworkModal,
    OutOfNetworkContainerView,
};
